import { render, staticRenderFns } from "./RoomStatusDetailReservationTab.vue?vue&type=template&id=5268eb26&scoped=true"
import script from "./RoomStatusDetailReservationTab.vue?vue&type=script&lang=js"
export * from "./RoomStatusDetailReservationTab.vue?vue&type=script&lang=js"
import style1 from "./RoomStatusDetailReservationTab.vue?vue&type=style&index=1&id=5268eb26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5268eb26",
  null
  
)

export default component.exports